export const FETCH_ATTENDEES = 'FETCH_ATTENDEES'
export const SET_ATTENDEES = 'SET_ATTENDEES'
export const FETCH_MEMBER_DIECTORY = 'FETCH_MEMBER_DIECTORY'
export const SET_MEMBER_DIECTORY = 'SET_MEMBER_DIECTORY'
export const FETCH_RESOURCES = 'FETCH_RESOURCES'
export const SET_RESOURCE_COLLECTIONS = 'SET_RESOURCE_COLLECTIONS'
